// src/features/executive/sales/drill/TopDoctorsDrill.tsx
import { Box, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useTopDoctors } from '../hooks/use-top-doctors'
import DrillTable from 'features/executive/components/DrillTable/DrillTable'
import type { ExecutiveState } from 'app/slice/executive.slice'
import { formatCurrency } from 'utils/executive.utils'
import { useRegisterDrillExport } from 'features/executive/components/DrillDrawer/DrillExportContext'

export default function TopDoctorsDrill() {
  const { t } = useTranslation()
  const stack = useSelector((s: { executive: ExecutiveState }) => s.executive.drillStack)
  const top = stack[stack.length - 1]
  const { data, loading, error, refetch } = useTopDoctors(top?.scopedFilters)

  const widgetTitle = top?.label ?? t('EXECUTIVE.SALES.TOP_DOCTORS.TITLE')
  useRegisterDrillExport(
    data ? { drillId: 'top-doctors', data } : null,
    'sales.top-doctors',
    widgetTitle
  )

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {top?.label ?? t('EXECUTIVE.SALES.TOP_DOCTORS.TITLE')}
      </Typography>
      <DrillTable
        rows={data?.items ?? []}
        columns={[
          { key: 'rank', label: t('EXECUTIVE.SALES.COLUMN.RANK'), render: (_r, idx) => idx + 1 },
          { key: 'name', label: t('EXECUTIVE.SALES.COLUMN.NAME'), render: (r) => r.doctorName },
          { key: 'cases', label: t('EXECUTIVE.SALES.COLUMN.CASES'), align: 'right', render: (r) => r.caseCount },
          { key: 'revenue', label: t('EXECUTIVE.SALES.COLUMN.REVENUE'), align: 'right', render: (r) => formatCurrency(r.revenue) },
          { key: 'avg', label: t('EXECUTIVE.SALES.COLUMN.AVG_PER_CASE'), align: 'right', render: (r) => formatCurrency(r.avgPerCase) },
        ]}
        loading={loading}
        error={error}
        onRetry={refetch}
      />
    </Box>
  )
}
